import __vue_component__ from '../Button/Button.vue.js';

//
var script = {
  name: 'Footer',
  components: {
    Button: __vue_component__
  },
  props: {
    appearance: {
      type: String,
      default: 'primary'
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => ['Continue', 'Cancel']
    },
    pending: {
      type: Boolean,
      default: false
    },
    shouldAllowSubmit: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      submit: 'Continue',
      cancel: 'Cancel'
    };
  },

  watch: {
    actions: {
      handler(actions = ['Continue', 'Cancel']) {
        const [submit, cancel] = actions;
        this.submit = submit;
        this.cancel = cancel;
      },

      immediate: true
    }
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Modal/Footer.vue_rollup-plugin-vue=script.js